module.exports = __webpack_public_path__ + "static/media/welcome-to-heto.01ad1f06.svg";